import { useState, useEffect, useMemo } from "react"
import { useRegisterActions, Action } from "kbar"
import { HEADING_EXTRACT_DELAY } from "../constants"
import { useCurrentRepo } from "../hooks/useCurrentRepo"
import type { Heading } from "../types"

export function CurrentPageHeadings() {
  const currentRepo = useCurrentRepo()

  // Only show "On this page" when inside docs context
  if (!currentRepo) {
    return null
  }

  const [headings, setHeadings] = useState<Heading[]>([])
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : null

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined
    }

    const extractHeadings = () => {
      const headingElements = document.querySelectorAll("h2, h3")
      const extracted = Array.from(headingElements)
        .map((heading) => ({
          id: heading.id || "",
          text: heading.textContent || "",
          level: parseInt(heading.tagName.charAt(1), 10),
        }))
        .filter((h) => h.id && h.text)

      setHeadings(extracted)
    }

    const timer = setTimeout(extractHeadings, HEADING_EXTRACT_DELAY)

    return () => {
      clearTimeout(timer)
    }
  }, [pathname])

  const actions: Action[] = useMemo(
    () =>
      headings.map((heading) => ({
        id: `heading-${heading.id}`,
        name: heading.text,
        section: "On this page",
        keywords: heading.text,
        perform: () => {
          if (typeof window !== "undefined") {
            const element = document.getElementById(heading.id)
            if (element) {
              element.scrollIntoView({ behavior: "smooth", block: "start" })
              window.history.pushState(null, "", `#${heading.id}`)
            }
          }
        },
      })),
    [headings]
  )

  useRegisterActions(actions, [actions])
  return null
}
